import { Getters } from 'vuex-smart-module';
import WidgetsState from './state';

export default class WidgetsGetters extends Getters<WidgetsState> {}
